<div class="bottom-sheet">
    @if (product) {
        <div class="heading">
            <span class="title">Would you like to repeat customization?</span>
            <span class="product-subcategory">{{ product.subcategory_name }}</span>
        </div>
    }

    <div class="product-label">
        <div style="display: flex">
            <div class="desc-icon" [ngClass]="{ veg: data?.is_veg, 'non-veg': !data?.is_veg }"></div>
            <div>
                <span>{{ product.label }}</span>
                @if (isObject(data.description)) {
                    <div class="combo-description">
                        @for (desc of getObjectKeys(data?.description); track desc) {
                            <div class="description-container">
                                <div
                                    [ngClass]="{
                                        veg: data?.description[desc].veg,
                                        'non-veg': !data?.description[desc].veg
                                    }"></div>
                                <p class="product-description">{{ data?.description[desc].label.join(', ') }}</p>
                            </div>
                        }
                    </div>
                } @else {
                    <p class="product-description">{{ data.description }}</p>
                }
            </div>
        </div>

        <div style="margin-left: 6px">
            @if (data?.marked_price > data?.price) {
                <span>
                    <span class="strikethrough">&#8377;&nbsp;{{ data.marked_price }}&nbsp;</span>
                </span>
            }
            <span>&#8377;&nbsp;{{ data.price }}</span>
        </div>
    </div>

    <div class="button-container">
        <button btn-primary-border (click)="submit('add-new')">Add New</button>
        <button btn-primary (click)="submit('repeat-last')">Repeat Last</button>
    </div>
</div>
